import { Link } from 'react-router-dom';
import imgGreenBird from '../../assets/greenbird.png';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css"; // Optional for blur effect
import { Music } from 'lucide-react';

const PlaylistCard = ({ playlist }) => {
    return (
        <Link to={`/playlist?id=${playlist?.playlist_slug}`} className="relative block group">
        {/* Stacked cards container */}
        <div className="relative w-full aspect-[16/9] group">
            {/* Bottom stacked cards */}
            <div className="absolute left-[7%] -top-[3%] w-[86%] h-[92%] bg-slate-500 dark:bg-slate-700 rounded-lg transform -translate-y-[8%] shadow-md group-hover:translate-y-0 transition-transform duration-300" />
            <div className="absolute left-[3.5%] -top-[2%] w-[93%] h-[96%] bg-slate-600 dark:bg-slate-700/95 rounded-lg transform -translate-y-[4%] shadow-lg group-hover:translate-y-0 transition-transform duration-300" />
            {/* Main card */}
            <div className="relative w-full h-full overflow-hidden bg-slate-900 shadow-xl rounded-t-lg">
                {/* Cover image */}
                <LazyLoadImage effect="blur" src={playlist.cover_image || imgGreenBird} alt={playlist.name} className="w-full h-full object-cover" loading="lazy" />
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black/10" />
                {/* Song count badge */}
                <div className="absolute bottom-0.5 right-0.5 bg-black/85 backdrop-blur-sm px-2.5 py-1 rounded-sm flex items-center gap-1 text-white z-20">
                    <span className="font-normal text-xs">
                        {playlist?.song_count || 0}
                    </span>
                    <div className="flex flex-col gap-[2px]">
                        <Music className="w-3 h-3 text-white" />
                    </div>
                </div>
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            </div>
        </div>
        
        {/* Title section - Now styled as a connected card */}
        <div className="relative -mt-[1px]"> {/* Negative margin to overlap and hide the gap */}
            <div className="bg-slate-950 rounded-b-lg shadow-lg shadow-green-700/20 border-t border-slate-700/20 py-1.5 px-3">
                <h3 className="text-white font-medium text-sm sm:text-base truncate group-hover:text-green-400 dark:group-hover:text-pink-400 transition-colors duration-200 relative z-10">
                    {playlist?.name || 'Hello'}
                </h3>
                {/* Subtle gradient background for hover effect */}
                <div className="absolute inset-0 bg-gradient-to-t from-green-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-lg" />
            </div>
        </div>
    </Link>
    )
}

export default PlaylistCard